<template>
  <v-col md="5">
    <v-card class="neu-glow">
      <v-row class="mx-0 pa-4" justify="space-between" align="center">
        <!-- title and subtitle -->
        <div>
          <div class="text-h6 float-left mr-1" v-text="$t('Dashboard.headingRevenue')"></div>
          <div class="text-h6 float-left">: {{formattedAmount(this.user.d_charts.TotSales[0])}} | {{formattedAmount(this.user.d_charts.TotPurchases[0])}}</div>
        </div>
        <!-- Stats -->
        <div class="d-flex flex-column align-end">
          <v-bottom-navigation
            v-model="showingTasks"
            color="secondary"
            class="neu-glow with-radius"
            height="40"
          >
            <v-btn value="View All" to='./reports/cogs'>
              <span v-text="$t('Dashboard.viewAll')"></span>
            </v-btn>
          </v-bottom-navigation>
        </div>
      </v-row>
      <v-card-text class="py-0">
        <line-chart v-if="data"
            :data="buildChart"
            :options="settings.line_option"
            :style="{ height: '300px' }"
            class="pt-5"
            id='Chart'
        />
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import { mapGetters } from "vuex";
import colors from "vuetify/lib/util/colors";
import LineChart from "@/components/ChartJS/LineChart";
export default {
  components: { LineChart },
  computed : {
    ...mapGetters(["user","settings","formattedTimeframe","formattedAmount","formattedNumber"]),
    buildChart(){
      this.data.labels = this.user.d_charts.labels_chart;
      this.data.datasets=[];
      let enabled=['Purchases','Sales'];
      enabled.forEach( e =>
      {                  
        if (this.user.d_charts[e])
        {
          if (this.user.d_charts[e].reduce((a, b) => a + b, 0)>0) 
          {
            let lc={"Sales":[colors.mygreen.lighten2, colors.mygreen.lighten2],"Purchases":[colors.red.base, colors.red.accent3],"walmart":[colors.blue.base, colors.blue.accent3],"rakuten":[colors.orange.base, colors.orange.accent4],"total":[colors.red.base, colors.red.accent4]};
            this.empty_dataset.label=e;//e.charAt(0).toUpperCase() + e.slice;
            this.empty_dataset.data = this.user.d_charts[e];
            this.empty_dataset.gradientStroke= lc[e];
            this.data.datasets.push(JSON.parse(JSON.stringify(this.empty_dataset)));
          }
        }
      });
      return this.data;
    },
  },
  data() {
    return {
      namespace: "Dashboard",
      page: "Dashboard",
      loading:false,
      errorid: null,
      showingTasks: "View All",
      empty_dataset:
      {
        label: '',
        yAxisID:1,
        fill: false,
        data: null,
        shadowOffsetX: 3,
        shadowOffsetY: 3,
        shadowBlur: 10,
        shadowColor: "rgba(103, 116, 132, 0.5)",
        pointRadius: 4,
        pointBevelWidth: 3,
        pointHoverRadius: 6,
        pointHoverBevelWidth: 4.5,
        pointHoverInnerGlowWidth: 20,
        pointHoverInnerGlowColor: `rgba(103, 116, 132, 0.5)`,
        gradientStroke: [colors.mygreen.darken2, colors.mygreen.darken2],
      },
      data: 
      {
        labels: null,
        datasets: null
      },
    };
  },
  methods:
  {
    beforeDestroy() {
      this.chartProperties = null;
      delete this.chartProperties;
    },
  }
}
</script>